import { render, staticRenderFns } from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=template&id=5f4953f4"
import script from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=script&lang=ts"
export * from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=script&lang=ts"
import style0 from "./ThgQuoteWorkitemRegistrationCard.vue?vue&type=style&index=0&id=5f4953f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VForm,VTextField})
